import { format, parseJSON } from "date-fns";
import { HiLockClosed } from "react-icons/hi";
import LinkAnchor from "../components/LinkAnchor";
import {
    CreateQuestionnaire,
    EntityTypeViewModel,
    EntityViewModel,
    GetEntity,
    GetEntityType,
    GetQuestionnaireType,
    QuestionnaireTypeViewModel,
    QuestionnaireViewModel,
} from "../utils/ServiceManagerAPI";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEntityAction } from "../components/EntityActionContext";
import "../main.css";

const EntityForms = () => {
    const [isSmall] = React.useState(() => window.innerWidth < 768);
    const { entityId } = useParams();

    React.useEffect(() => {
        if (entityId) {
            refreshEntity(entityId);
            setActions([]);
        }
    }, [entityId]);

    const [loading, setLoading] = React.useState(true);

    const navigate = useNavigate();
    const { setActions } = useEntityAction();

    const refreshEntity = (id) => {
        return Promise.all([
            GetEntityType(EntityTypeID).then((res) => {
                setEntityDataForms(res.value.questionnaireTypes?.filter((qt) => qt.subjectType == 5) || []);
            }),
            GetEntity(id).then((res) => {
                setEntityData(res.value.data);
            }),
        ]).then(() => {
            setLoading(false);
        });
    };

    const [entityDataForms, setEntityDataForms] = React.useState<QuestionnaireTypeViewModel[]>([]);
    const [entityData, setEntityData] = React.useState<QuestionnaireViewModel[]>([]);

    const createEntityDataForm = (name, organizationID, questionnaireTypeID, entityID) => {
        CreateQuestionnaire({ name: name, organizationID: organizationID, questionnaireTypeID: questionnaireTypeID, subjectID: entityID }).then((res) => {
            navigate(`/entities/${entityID}/questionnaires/` + res);
        });
    };
    return (
        <>
            <div className="flex flex-row gap-2 py-2">
                {entityDataForms.map((dataForm) => (
                    <button 
                        key={dataForm.id} 
                        className="px-4 py-2 rounded bg-brand text-white hover:bg-brand-dark transition-colors"
                        onClick={() => createEntityDataForm(dataForm.name, dataForm.organizationID, dataForm.id, entityId)}
                    >
                        New {dataForm.name}
                    </button>
                ))}
            </div>
            <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="border-b border-gray-300 dark:border-gray-600">
                            <th className="text-left p-2 w-8"></th>
                            <th className="text-left p-2 text-gray-900 dark:text-gray-100 font-semibold">Name</th>
                            <th className="text-left p-2 text-gray-900 dark:text-gray-100 font-semibold">Created</th>
                            <th className="text-left p-2 text-gray-900 dark:text-gray-100 font-semibold">Submitted</th>
                            {isSmall && <th className="text-left p-2"></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {entityData.map((datum: QuestionnaireViewModel) => (
                            <tr key={datum.id} className="border-b border-gray-200 dark:border-gray-700">
                                <td className="p-2">
                                    {datum.locked ? <HiLockClosed size="18px" className="text-gray-500" /> : <></>}
                                </td>
                                <td className="p-2">
                                    <div className="flex flex-col gap-1">
                                        <LinkAnchor path={`/entities/${entityId}/questionnaires/${datum.id}`} label={datum.name || "Unnamed Entity"}></LinkAnchor>
                                        <div className="flex flex-row gap-2 flex-wrap">
                                            {datum.questionnaireScopes?.map((scope, i) => (
                                                <div className="flex flex-row gap-1" key={scope.id}>
                                                    <span className="text-sm text-gray-500 dark:text-gray-400">{scope.scopeTypeSequence.name}</span>
                                                    <span className="text-sm text-gray-500 dark:text-gray-400">{scope.formattedSequenceNumber}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </td>
                                <td className="p-2">
                                    <span className="text-gray-900 dark:text-gray-100">{!!datum.timestamp && format(parseJSON(datum.timestamp), "dd MMM yyy HH:mm")}</span>
                                </td>
                                <td className="p-2">
                                    <span className="text-gray-900 dark:text-gray-100">{!!datum.lastSubmissionDate && format(parseJSON(datum.lastSubmissionDate), "dd MMM yyy HH:mm")}</span>
                                </td>
                                {isSmall && (
                                    <td className="p-2">
                                        <div className="flex flex-row gap-2">
                                            <button 
                                                className="px-3 py-1 rounded bg-brand text-white hover:bg-brand-dark transition-colors text-sm"
                                                onClick={() => navigate(`/questionnaires/${datum.id}`)}
                                            >
                                                View Data
                                            </button>
                                        </div>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default EntityForms;
